import React from "react";
import { SSH_FeatureHandler } from "../../../helpers/FeatureHandler.helper";
import { V1 } from "./v1/ListOfEmployeesV1.component";

const featureName = "ListOfEmployees";
const versions = {
    v1: V1,
};

export const SSH_ListOfEmployees = React.forwardRef(({ version, ...props }: any, ref: any) => (
    <SSH_FeatureHandler
        featureName={featureName}
        featureVersions={versions}
        version={version}
        {...props}
        ref={ref}
    />
));

SSH_ListOfEmployees.displayName = "SSH_ListOfEmployees";
